import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { CheckIcon, Sparkles, Clock, Infinity, Gift } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export const PricingSection = () => {
  const { showAuthModal } = useAuth();
  const navigate = useNavigate();

  const yearlyPrice = 16.90;

  const handleFreeStart = () => {
    showAuthModal('register');
  };

  const handlePremiumUpgrade = () => {
    showAuthModal('register');
  };

  return (
    <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
      {/* Free Plan */}
      <Card className="relative bg-white border border-gray-200 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden flex flex-col">
        <CardHeader className="text-center p-8 pb-6">
          <CardTitle className="text-2xl font-bold text-gray-900 mb-2">Kostenlos</CardTitle>
          <CardDescription className="text-gray-600 mb-6">
            Perfekt zum Ausprobieren
          </CardDescription>
          <div className="mb-6">
            <span className="text-4xl font-bold text-gray-900">0€</span>
            <span className="text-gray-600 ml-2">/für immer</span>
          </div>
        </CardHeader>
        <CardContent className="px-8 pb-8 flex-1 flex flex-col">
          <ul className="space-y-4 mb-8">
            <li className="flex items-center gap-3">
              <CheckIcon className="w-5 h-5 text-emerald-500 flex-shrink-0" />
              <span className="text-gray-700">1 Produkt auf der Warteliste</span>
            </li>
          </ul>
          
          <div className="flex-1"></div>
          
          {/* 30 Tage Test Box */}
          <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-xl p-4 mb-6 border border-purple-100">
            <div className="flex items-center gap-3">
              <Gift className="w-5 h-5 text-purple-600 flex-shrink-0" />
              <div>
                <span className="text-purple-900 font-semibold text-sm">30 Tage kostenlos testen</span>
                <p className="text-purple-700 text-xs">Alle Premium-Features ausprobieren</p>
              </div>
            </div>
          </div>
          
          <Button 
            onClick={handleFreeStart}
            variant="outline" 
            className="w-full border-2 border-gray-300 hover:border-gray-400 hover:bg-gray-50 transition-all duration-200 py-3 rounded-xl"
          >
            Kostenlos starten
          </Button>
        </CardContent>
      </Card>

      {/* Premium Plan */}
      <Card className="relative bg-gradient-to-br from-emerald-50 to-green-50 border-2 border-emerald-200 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden flex flex-col">
        <div className="absolute top-4 right-4">
          <Badge className="bg-emerald-600 text-white px-3 py-1 rounded-full text-sm font-medium">
            <Sparkles className="w-3 h-3 mr-1" />
            Beliebt
          </Badge>
        </div>
        
        <CardHeader className="text-center p-8 pb-6">
          <CardTitle className="text-2xl font-bold text-emerald-900 mb-2">Jahres-Lizenz</CardTitle>
          <CardDescription className="text-emerald-700 mb-6">
            Für ernsthafte Sparer
          </CardDescription>
          <div className="mb-2">
            <span className="text-4xl font-bold text-emerald-900">16,90€</span>
            <span className="text-emerald-700 ml-2">/Jahr</span>
          </div>
          <p className="text-sm text-emerald-600">
            Nur 1,41€ pro Monat
          </p>
        </CardHeader>
        <CardContent className="px-8 pb-8 flex-1 flex flex-col">
          <ul className="space-y-4 mb-8">
            <li className="flex items-center gap-3">
              <Infinity className="w-5 h-5 text-emerald-600 flex-shrink-0" />
              <span className="text-gray-700 font-medium">Unbegrenzte Produkte</span>
            </li>
          </ul>
          
          <div className="flex-1"></div>
          
          {/* No Auto-Renewal Box */}
          <div className="bg-gradient-to-r from-blue-50 to-cyan-50 rounded-xl p-4 mb-6 border border-blue-100">
            <div className="flex items-center gap-3">
              <CheckIcon className="w-5 h-5 text-blue-600 flex-shrink-0" />
              <div>
                <span className="text-blue-900 font-semibold text-sm">Keine automatische Verlängerung</span>
                <p className="text-blue-700 text-xs">Einmalige Zahlung - keine Abo-Falle</p>
              </div>
            </div>
          </div>
          
          <Button 
            onClick={handlePremiumUpgrade}
            className="w-full bg-gradient-to-r from-emerald-600 to-green-600 hover:from-emerald-700 hover:to-green-700 text-white py-3 rounded-xl shadow-lg hover:shadow-xl transition-all duration-200"
          >
            <Sparkles className="w-4 h-4 mr-2" />
            Premium freischalten
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};
